import { render, staticRenderFns } from "./StorageUpgradeRecord.vue?vue&type=template&id=f5867566"
import script from "./StorageUpgradeRecord.vue?vue&type=script&lang=js"
export * from "./StorageUpgradeRecord.vue?vue&type=script&lang=js"
import style0 from "./StorageUpgradeRecord.vue?vue&type=style&index=0&id=f5867566&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VImg,VPagination,VRow,VSimpleTable,VTextField})
